// src/config.js

const config = {
  API_URL: "https://liqourmart.co.ke/cms/public",
  APP_URL: "https://liqourmart.co.ke",
  LOGO_URL: "https://liqourmart.co.ke/liqourmart.png",
  BASE_COLOR:'#990012',
  WEB_URL:"",
  STORE_NAME:"LiqourMart",
  STORE_LOGAN:"",
  FONT_FAMILY:'Quicksand',
};


/**const config = {
  API_URL: "https://sefams.emagetechnologiesltd.com/shule/public",
  APP_URL: "https://sefams.emagetechnologiesltd.com",
  BASE_COLOR:'#e65c00',
  WEB_URL:"",
  STORE_NAME:"",
  STORE_LOGAN:"",
  FONT_FAMILY:'Quicksand',
};

const config = {
  API_URL: "http://127.0.0.1:8000",
  APP_URL: "http://127.0.0.1:3000",
  LOGO_URL: "http://127.0.0.1:3000/liqourmart.png",
  BASE_COLOR:'#990012',
  WEB_URL:"",
  STORE_NAME:"LiqourMart",
  STORE_LOGAN:"",
  FONT_FAMILY:'Quicksand',
};

/**
 * 
const config = {
  API_URL: "https://admins.junisaproducts.com",
  APP_URL: "https://admins.junisaproducts.com/admin/payroll_",
  BASE_COLOR:'#e65c00',
  WEB_URL:"",
  STORE_NAME:"",
  STORE_LOGAN:"",
  FONT_FAMILY:'Quicksand',
};

**/
/**const config = {
  API_URL: "https://finance.insigniah2o.co.ke/cms/public",
  APP_URL: "https://finance.insigniah2o.co.ke",
  BASE_COLOR:'#e65c00',
  WEB_URL:"",
  STORE_NAME:"",
  STORE_LOGAN:"",
  FONT_FAMILY:'Quicksand',
};**/

/**
const config = {
  API_URL: "https://finance.joharischool.co.ke/shule/public",
  APP_URL: "https://finance.joharischool.co.ke",
  BASE_COLOR:'#e65c00',
  WEB_URL:"",
  STORE_NAME:"",
  STORE_LOGAN:"",
  FONT_FAMILY:'Quicksand',
};
const config = {
  API_URL: "https://cms.junisaproducts.com/cms/public",
  BASE_COLOR:'#e65c00',
  WEB_URL:"",
  APP_URL: "https://cms.junisaproducts.com",
  FONT_FAMILY:'Quicksand',
};



**/
/**
const config = {
  API_URL: "https://salesapp.infinitivelogic.com",
  APP_URL: "https://salesapp.infinitivelogic.com/salesapp",
  BASE_COLOR:'#e65c00',
  WEB_URL:"",
  STORE_NAME:"",
  STORE_LOGAN:"",
  FONT_FAMILY:'Quicksand',
};

const config = {
  API_URL: "https://junisaproducts.com/cms/public",
  BASE_COLOR:'#e65c00',
  WEB_URL:"",
  APP_URL: "https://junisaproducts.com",
  FONT_FAMILY:'Quicksand',
};

**/



export default config;
